module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "send-love-section",
    class: {
      transparent: _vm.showPaymentModal
    },
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [(!_vm.showPaymentModal) ? _c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showPaymentModal) ? _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "top-section"
  }, [_c('p', {
    staticClass: "title-label"
  }, [_vm._v("Send payment to")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "profile-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.item.username) + "\n        "), (_vm.item.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.item.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "avatar-image",
    style: ({
      'background-image': 'url(' + _vm.item.avatar.thumb.url + ')'
    })
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "input-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-numeric', {
    staticClass: "donate-amount",
    attrs: {
      "currency": "$",
      "separator": ",",
      "min": 1
    },
    model: {
      value: (_vm.donate_amount),
      callback: function($$v) {
        _vm.donate_amount = $$v
      },
      expression: "donate_amount"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "pt-4",
    attrs: {
      "items": _vm.descriptions,
      "hide-details": ""
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _vm._v(" "), (_vm.description === 'Add Video Credit') ? _c('p', [_vm._v("\n        Adding video credit gives this user more time to broadcast live video\n      ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "download-btn",
    nativeOn: {
      "click": function($event) {
        _vm.showPaymentDialog()
      }
    }
  }, [_vm._v("\n        Go to checkout\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPaymentModal) ? _c('payment-modal', {
    attrs: {
      "receivers": [_vm.item],
      "amount": _vm.donate_amount_by_cent,
      "dismiss": _vm.hidePaymentDialog,
      "finish": _vm.sendLove
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e9b7138","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sendlovemodal.vue
// module id = 1718
// module chunks = 180